import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {ManufacturerEntityModel} from "../manufacturer-entity.model";
import {ChangeDetectorRef, Component} from "@angular/core";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-manufacturer-edit-page",
    templateUrl: "./manufacturer-edit-page.component.html",
    providers: [provideEntityModel(ManufacturerEntityModel)]
})
export class ManufacturerEditPageComponent extends AbstractEditPage {
    constructor(public model: ManufacturerEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
    }
}
